import { render, staticRenderFns } from "./phoneExtItemForm.vue?vue&type=template&id=6b7a823b&scoped=true&"
import script from "./phoneExtItemForm.vue?vue&type=script&lang=js&"
export * from "./phoneExtItemForm.vue?vue&type=script&lang=js&"
import style0 from "./phoneExtItemForm.vue?vue&type=style&index=0&id=6b7a823b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a823b",
  null
  
)

export default component.exports